/**
 * Wrap config to operate on partitioned endpoints.
 */
export class PartitionCoralClientConfigFactory {
    constructor(partition, factory) {
        this.service = factory.service;
        this.getConfigForQualifier = (qualifier) => {
            const config = factory.getConfigForQualifier(qualifier);
            return Object.assign(Object.assign({}, config), { httpEndpoint: Object.assign(Object.assign({}, config.httpEndpoint), { url: config.httpEndpoint.url.replace(/\bPARTITION\b/, partition) }) });
        };
    }
}
